import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth';
import axios from 'axios';
import SaveStepButton from './SaveStepButton';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import CustomAlert from './CustomAlert.js';
import Whatsapp from './WhatsappButton.js';
import renderField from './renderField';
import { connect } from 'react-redux';

class SuretyForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
			isCompany: null,
            factoBusinessAssociation: null,
	  }
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };

        axios.get(`${ROOT_URL}/leads/details`, config).then((response)=> {
            this.setState({
              isCompany: response.data.is_company,
              factoBusinessAssociation: response.data.facto_business_association,
            });
        });
      }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_surety" description="Surety"/>
                        <div className="show-desktop">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.setSurety)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            {this.state.isCompany && !this.state.factoBusinessAssociation &&
                                <div className="col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name={`name`} autoComplete="off" component={renderField} type="text" label="Nombre y Apellido" />
                                    </div>
                                </div>
                            }
                            <div className="col-md-12 col-lg-12">
                                <div className="form-group">
                                    <Field className="form-control" name={`cuil`} autoComplete="off" component={renderField} type="cuil" label="Número de Cuil" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

SuretyForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

SuretyForm = TopScrolleable(SuretyForm);

SuretyForm = reduxForm({
    form: 'SuretyForm', // a unique name for this form
})(SuretyForm);

SuretyForm = connect(state => ({
    isCompany: state.isCompany,
    factoBusinessAssociation: state.factoBusinessAssociation
}))(SuretyForm);

SuretyForm = withAuthControl(SuretyForm);

export default SuretyForm;


/** WEBPACK FOOTER **
 ** ./src/components/SuretyForm.js
 **/